import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: block;
    content: none;
    cursor: pointer;
    @apply --user-select-none;
    @apply --heavy;
    color: var(--primary-action, #0079BC);
  }
  .com-icon {
    @apply --layout-center;
  }
  :host(:focus),
  :host(:hover) {
    outline: none;
    color: var(--primary-hover);
  }

  :host(:focus) {
    @apply --focus;
    @apply --com-calendar-button-focus-styles;
  }

  :host(:active) {
    outline: none;
    color: var(--primary-active);
  }

  :host([disabled]) {
    cursor: default;
    pointer-events: none;
    color: var(--inactive-grey);
  }
</style>
</template>`;

styleElement.register('com-calendar-button-style');